<template>
  <div class="consultant-list clearfix" ref="consultantWraper">
    <div class="consultants__item" v-for="(item, index) in consultantList" :key="index">
      <div class="consultants__item-box clearfix" @click="itemClick(item)">
        <div class="consultants__img">
          <img :src="item.logoUrl" :alt="item.name">
        </div>
        <div class="consultants__desc">
          <div class="consultants__name">{{item.name}}</div>
          <div class="consultants__job">{{item.profession}}</div>
          <div class="consultants__phone"><span class="iconfont phone">&#xe657;</span>：{{prefix(item.phone)}}</div>
          <div class="consultants__wechat"><span class="iconfont wechat">&#xe758;</span>：{{item.wechat}}</div>
          <div class="consultants__order" @click.stop="order(item)">立即预约</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      consultantList: {
        type: Array,
        require: true
      }
    },
    methods: {
      prefix (str) {
        if (str.length !== 11) return str
        return str.replace(/(\d{3})(\d{4})(\d{4})/, ($0, $1, $2, $3) => {
          return $1 + '-' + $2 + '-' + $3
        })
      },
      /**
       * 贷款顾问跳转
       * @param item
       */
      itemClick (item) {
        this.$router.push(`/consultant/consultant-articles/${item.uid}`)
      },
      /**
       * 贷款预约
       * @param item
       */
      order (item) {
        this.loanReservationStatistics(item.uid)
        this.$store.commit('toggleAppointment', {show: true, id: item.uid})
      },
      // 贷款预约统计
      loanReservationStatistics (counselorId) {
        let from = this.$route.path.split('/').some(str => str === 'article') ? 'article' : 'counselor'
        let articleId = this.$route.query.articleId || ''
        this.$http({
          url: '/loanReservationStatistics.jhtml',
          data: {
            from: from,
            counselorId: counselorId,
            articleId: articleId
          }
        })
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  @import '../../stylus/mixin'
  .consultant-list
    margin-left -20px
    margin-top -20px

  .consultants__item
    float left
    padding 19px 18px
    width 326px
    height 208px
    background-image url(/static/img/consultant-item-bg2.png)
    background-repeat no-repeat
    > .consultants__item-box
      padding 10px 8px
      cursor pointer
    &:nth-child(3n)
      margin-right -28px
  .consultants__img
    float left
    width 118px
    height 150px
    border-radius 4px
    overflow hidden
    border 1px solid rgb(238, 238, 238)
    img
      display block
      width 100%
      height 100%
  .consultants__desc
    float right
    width 154px
    text-align center
    margin-top -2px
    .consultants__name, .consultants__job
      height 26px
      line-height 26px
      font-size 14px
      font-weight bold
      margin 0 auto
      text-align center
      border-bottom 1px solid #e4e4e4
      letter-spacing 2px
      ellipsis()
    .consultants__name
      width 72px
    .consultants__job
      width 128px
      font-weight normal
      font-size 12px
    .consultants__phone, .consultants__wechat
      width 150px
      line-height 20px
      font-size 14px
      font-weight bold
      margin 0 auto
      text-align left
      margin-top 8px
      ellipsis()
      .iconfont.phone,.iconfont.wechat
        text-align center
        width 18px
        float left
        margin-top 1px
        font-size 16px
        color #848f9e
      .iconfont.wechat
        font-size 18px
        color #73b666
    .consultants__order
      margin 10px auto 0
      cursor pointer
      width 122px
      height 30px
      line-height 30px
      border-radius 5px
      color #fff
      background-color rgb(43, 158, 252)
  .item-wrap
    margin 0 auto 18px
    background-image url("/static/img/consultant-bg.png")
    background-repeat no-repeat
    background-position center
    background-attachment fixed
    background-size cover
    .item
      height 288px
      margin 0 auto
      padding 20px 10px
      background-color rgba(0, 0, 0, .5)
      box-shadow 0 3px 18px 0 rgba(35, 55, 73, .35)
      .item-left
        width 227px
        height 250px
        > img
          width 100%
          height 100%
      .item-center
        width 350px
        margin 0 20px
        padding 0
        font-size 16px
        color #fff
        > h2
          margin-top 0
          height 35px
          overflow hidden
          margin-bottom 15px
          font-size 0
          .name
            display inline-block
            max-width 160px
            ellipsis()
            font-size 32px
          .job
            display inline-block
            max-width 170px
            margin-left 20px
            ellipsis()
            font-size 18px
        ul.inner > li.inner-item
          ellipsis()
        .specialty
          height 72px
          overflow hidden
          line-height 24px
          font-weight 700
        .inner
          margin-bottom 0
          padding-left 0
          list-style-type none
          border-top 1px solid rgba(255, 255, 255, .2)
          .inner-item
            margin-top 5px
            font-size 25px
            font-family 'DINCondBold'
            letter-spacing 1px
            .iconfont
              font-size 25px
      .item-right
        width 500px
        padding-left 10px
        padding-right 0
        .datagrid
          color #b8c8d7
          .datagrid-item
            background-color transparent
            &:nth-child(odd)
              background-color rgba(255, 255, 255, .2)
            .date
              color #b8c8d7
            .title a
              color #b8c8d7
            .title .tag
              color #b8c8d7
          .list-group-item
            padding 8px 10px

</style>



// WEBPACK FOOTER //
// consultant-list.vue?6383974e